import { ComponentType } from 'react';
import Loadable from '../../common/loadable';

const RoutePage = Loadable({
  name: 'RoutePage',
  ebdcoms: true,
  loader: () => import(
    /* webpackChunkName: "page_routepage" */
    /* webpackMode: "eager" */
    './Page'
  ),
}) as ComponentType<any>;

export default RoutePage;
